import React from 'react';
import cx from 'classnames';
const styles = require('./index.less');

export default class TextDotAnimation extends React.PureComponent {
  render() {
    const { children, className, animationChar, wrapChildrenClass, wrapLoadingDotClass, ...restProps } = this.props;
    return (
      <div className={cx(styles.root, className)} {...restProps}>
        <span className={cx(styles.loadingText, wrapChildrenClass)}>{children}</span>
        <span className={cx(styles.loadingDot, wrapLoadingDotClass)}>{animationChar}</span>
      </div>
    );
  }
}

TextDotAnimation.defaultProps = {
  animationChar: '.'
};
